/**
 * Redux App Settings Actions
 */
import {
    AGENCY_TOGGLE_MENU,
    BOXED_LAYOUT,
    CHANGE_AGENCY_LAYOUT_BG,
    CHANGE_THEME_COLOR,
    CHANGE_USER_TOUR_STEP,
    COLLAPSED_SIDEBAR,
    DARK_MODE,
    MINI_SIDEBAR,
    RTL_LAYOUT,
    SEARCH_FORM_ENABLE,
    SET_CONTACT_US_DIALOG_MESSAGE,
    SET_LANGUAGE,
    SET_SIDEBAR_IMAGE,
    SET_USER_TOUR_AUTO_START,
    START_USER_TOUR,
    STOP_USER_TOUR,
    TOGGLE_DARK_SIDENAV,
    TOGGLE_DEFAULT_TEMPLATE_DIALOG_OPEN,
    TOGGLE_MENU,
    TOGGLE_SIDEBAR_IMAGE,
} from './types';

/**
 * Redux Action To Emit Collapse Sidebar
 * @param {*boolean} isCollapsed
 */
export const collapsedSidebarAction = (isCollapsed) => ({
    type: COLLAPSED_SIDEBAR,
    isCollapsed,
});

/**
 * Redux Action To Start User Tour
 * @param {number} startPage
 * @returns {{payload: number, type: string}}
 */
export const startUserTour = (startPage = 0) => ({
    type: START_USER_TOUR,
    payload: startPage,
});

/**
 * Redux Action To Stop User Tour
 */
export const stopUserTour = () => ({
    type: STOP_USER_TOUR,
});

/**
 * Redux action to change user tour auto start
 * @param {boolean} value
 * @return {{payload: boolean, type: string}}
 */
export const changeUserTourAutoStart = (value) => ({
    type: SET_USER_TOUR_AUTO_START,
    payload: value,
});

/**
 * Redux action to change user tour step
 * @param {number} step
 * @returns {{payload: number, type: string}}
 */
export const changeUserTourStep = (step) => ({
    type: CHANGE_USER_TOUR_STEP,
    payload: step,
});

/**
 * Redux Action To Emit Dark Mode
 * @param {*boolean} isDarkMode
 */
export const darkModeAction = (isDarkMode) => ({
    type: DARK_MODE,
    payload: isDarkMode,
});

/**
 * Redux Action To Emit Boxed Layout
 * @param {*boolean} isBoxLayout
 */
export const boxLayoutAction = (isBoxLayout) => ({
    type: BOXED_LAYOUT,
    payload: isBoxLayout,
});

/**
 * Redux Action To Emit Rtl Layout
 *  @param {*boolean} isRtlLayout
 */
export const rtlLayoutAction = (isRtlLayout) => ({
    type: RTL_LAYOUT,
    payload: isRtlLayout,
});

/**
 * Redux Action To Toggle Sidebar Menus
 */
export const onToggleMenu = (selectedMenu) => ({
    type: TOGGLE_MENU,
    payload: selectedMenu,
});

/**
 * Redux Action To Toggle Agency Sidebar Menus
 */
export const onToggleAgencyMenu = (selectedAgencyMenu) => ({
    type: AGENCY_TOGGLE_MENU,
    payload: selectedAgencyMenu,
});

/**
 * Redux Action To Emit Mini Sidebar
 */
export const miniSidebarAction = (isMiniSidebar) => ({
    type: MINI_SIDEBAR,
    payload: isMiniSidebar,
});

/**
 * Redux Action To Enable/Disable The Search Form
 */
export const toggleSearchForm = () => ({
    type: SEARCH_FORM_ENABLE,
});

/**
 * Reduc Action To Change Theme Colors
 */
export const changeThemeColor = (theme) => ({
    type: CHANGE_THEME_COLOR,
    payload: theme,
});

/**
 * Redux Action To Enable/Disable Sidebar Background Image
 */
export const toggleSidebarImage = () => ({
    type: TOGGLE_SIDEBAR_IMAGE,
});

/**
 * Redux Action To Set Sidebar Background Image
 */
export const setSidebarBgImageAction = (sidebarImage) => ({
    type: SET_SIDEBAR_IMAGE,
    payload: sidebarImage,
});

/**
 * Redux Action To Set Language
 */
export const setLanguage = (language) => ({
    type: SET_LANGUAGE,
    payload: language,
});

/**
 * Redux Action To Toggle Dark Sidenav
 */
export const toggleDarkSidebar = () => ({
    type: TOGGLE_DARK_SIDENAV,
});

/**
 * Redux Action For Agency Layout Bg Handler
 */
export const agencyLayoutBgHandler = (color) => ({
    type: CHANGE_AGENCY_LAYOUT_BG,
    payload: color,
});

export const setContactUsDialogMessage = (jobs) => ({
    type: SET_CONTACT_US_DIALOG_MESSAGE,
    payload: jobs.message,
});

export const toggleDefaultTemplateDialogOpen = (isOpen) => ({
    type: TOGGLE_DEFAULT_TEMPLATE_DIALOG_OPEN,
    payload: isOpen,
});